import siteBase from "@/data/site-base.json";

export default {
  nav: {
    Home: "Home",
    Profile: "Profile",
    Project: "Project",
    Resume: "Resume",
    Blog: "Blog",
  },
  common: {
    ghost: "Ghost guide",
    self: "???",
    openSidebar: "Open sidebar",
    lightMode: "Light mode",
    darkMode: "Dark mode",
    switchToZh: "中文",
    switchToEn: "EN",
    open: "Open →",
    goToProject: "Go to project {n}",
  },
  search: {
    placeholder: "Search the woods…",
    loading: "Gathering memories from the forest…",
    noResults: 'Nothing stirs in the woods for "{query}"',
    categories: {
      Page: "Page",
      Profile: "Profile",
      Blog: "Blog",
      Project: "Project",
      Resume: "Resume",
    },
  },
  chat: {
    subtitle: "Ghost in the forest · AI guide",
    clearChat: "Clear chat",
    placeholder: "Whisper a question…",
    openChat: "Open AI chat",
    welcome: "…hello? I am a ghost in these woods. Visitors tell me stories. Ask me what I remember…",
    cleared: "…memories fade like mist. What would you like to know about?",
    error: "…the forest swallowed my thoughts. The spirits of the API are quiet. Try again later.",
  },
  home: {
    welcome: "Ah, another guest. Welcome! Come join us by the fire.",
    cards: {
      profile: { title: "Wh...who are you?", link: "[To Profile]" },
      project: { title: "What are you doing here?", link: "[To Projects]" },
      resume: { title: "Why are you here?", link: "[To Resume]" },
      blog: { title: "Tell me what you remember?", link: "[To Blog]" },
    },
  },
  profile: {
    cards: {
      introduction: "Introduction",
      education: "Education",
      skills: "Skills",
      workExperience: "Work Experience",
    },
    introduction: {
      tagline: "- They say jump, you say how high -",
    },
    education: {
      title: "Education",
    },
    skills: {
      title: "Current Technologies",
      groups: {
        Frontend: "Frontend",
        Backend: "Backend",
        Infrastructure: "Infrastructure",
        Development: "Development",
        Others: "Others",
      },
    },
    workExperience: {
      title: "Work Experience",
    },
    dialogs: {
      default: [
        "It has been a while since I last talked to someone...",
        "This wood is quite lonely",
        "Maybe you can explore around and help me find some clues about myself?",
        "Visitors who comes here will tell me stories about the outside world",
        "and I will tell them stories about myself in return...",
        " but I can't remember much about myself",
        "so I will just repeat some of the stories I've heard before",
      ],
      introduction: [
        "(looking at the name tag) I... was a developer before I lost in this wood",
        "...but I can't remember anything else...",
        "Don't stay in this place for too long, or you might forget yourself too",
      ],
      education: [
        "University? I think I went to one...",
        "I heard universities are like... big schools?",
        "I think I studied computer engineering? But I can't remember what it is...",
      ],
      skills: [
        "Skills? I think I have some...",
        "Someone once said I am good at web development?",
        "Cloud services? I think I have some experience with them too...",
      ],
      workExperience: [
        "Work experience? I think I have some too...",
        "I remember... an office? I think I worked in an office before?",
        " But I can't remember what we did there... the wood is making me forget things too quickly...",
      ],
    },
  },
  project: {
    speech: "Someone has left his phone here and I used it to build some things...",
    title: "Things I Made",
  },
  resume: {
    speech:
      "I don't know why I am here but I found this paper with me when I woke up...",
    title: "Resume",
    pdfTitle: "Resume PDF",
    handAlt: "hand holding pen",
  },
  blog: {
    title: "Blog",
    loading: "Loading blog posts...",
    error: "Failed to load blog posts",
    toc: "Table of contents",
    readSingle: "Read as single page →",
    backToAll: "Back to all posts",
    postNotFound: "This memory has faded from the woods.",
  },
  notFound: {
    title: "Lost in the woods",
    message: "The path you followed leads nowhere. Even the ghost cannot find this page.",
    backHome: "Return to the fire",
  },
  site: {
    profile: {
      name: siteBase.profile.name,
      username: siteBase.profile.username,
      tagline: siteBase.profile.tagline,
    },
    education: siteBase.education,
    skills: siteBase.skills,
    workExperience: siteBase.workExperience,
    projects: siteBase.projects.map(({ title, category, blurb }) => ({
      title,
      category,
      blurb,
    })),
    navPages: siteBase.navPages,
    cvSummary: siteBase.cvSummary,
    search: {
      introTitle: "{name} — Introduction",
      educationTitle: "Education",
      skillsTitle: "Skills & Technologies",
      resumeTitle: "Resume / CV",
    },
  },
};
